import UsersIcon from '@heroicons/react/outline/UsersIcon'

import { I18nShape } from '@tribeplatform/react-components/i18n'

export const MembersConfig = ({ $t }: I18nShape) => ({
  defaultProps: {
    title: '',
    description: '',
    sort: 'alphabetical',
    limit: 10,
    showTitle: true,
    showTagline: true,
    showViewAll: false,
    filterBy: [],
  },
  displayName: $t({
    defaultMessage: 'Members',
    id: 'Blocks.Members.DisplayName',
  }),
  removable: true,
  Icon: <UsersIcon />,
})
